
/**
 * Subscriptions Tab Help Content
 */
const SubscriptionsHelp = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Subscription Management
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Manage your Aivilo Lens subscription, view billing details, and update your plan settings.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Current Plan
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          View details about your current subscription:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Plan Type</span>: Your current subscription tier</p>
          <p>&#8226; <span className="font-medium">Usage Limits</span>: API calls, traces, and storage quotas</p>
          <p>&#8226; <span className="font-medium">Billing Cycle</span>: Monthly or annual billing period</p>
          <p>&#8226; <span className="font-medium">Next Renewal</span>: Date of next payment</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Upgrading Your Plan
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          To upgrade your subscription, contact your account manager or reach out to our sales team. Enterprise plans include dedicated support, custom integrations, and higher usage limits.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Usage Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Track your usage against plan limits to avoid service interruptions. You'll receive notifications when approaching usage thresholds.
        </p>
      </div>

      <div className="pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-500 dark:text-gray-500">
          For billing inquiries, contact{' '}
          <a
            href="mailto:billing@aivilo.ai"
            className="text-blue-600 dark:text-blue-400 hover:underline"
          >
            billing@aivilo.ai
          </a>
        </p>
      </div>
    </>
  );
};

export default SubscriptionsHelp;
